import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dry"}/>
}
